import Vue from 'vue';
import Router from 'vue-router';
import {routes} from './routes';
import sysConfig from '../configs/sys';

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes
});

// router.afterEach((to, from) => {});
router.beforeEach((to, from, next)=>{
  if (to.meta.auth !== false) {
    let token = sessionStorage.getItem('token');
    if (token) {
      // logic for role permision
      // if (to.meta.role && to.meta.role !== store.state.user.role) {
      //   router.push(from.path);
      // } else {
      //   next();
      // }
      console.log('[router] next - has token');
      next();
    } else {
      console.log('[router] next - no token');
      // not auth yet, go to signin page
      if (sysConfig.auth) {
        router.push({name: 'Signin'});
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
